/**
 * @fileoverview Chat Metadata Context - Provides workflow identifiers to nested components
 *
 * This context provides workflow_instance_id and workflow_execution_id to deeply nested
 * components without prop drilling, enabling features like behaviour action state management.
 */

import { createContext, useContext } from 'react';

interface ChatMetadataContextValue {
  workflowInstanceId?: string;
  workflowExecutionId?: string;
}

const ChatMetadataContext = createContext<ChatMetadataContextValue | undefined>(undefined);

export const ChatMetadataProvider: React.FC<{
  children: React.ReactNode;
  workflowInstanceId?: string;
  workflowExecutionId?: string;
}> = ({ children, workflowInstanceId, workflowExecutionId }) => {
  return (
    <ChatMetadataContext.Provider value={{ workflowInstanceId, workflowExecutionId }}>
      {children}
    </ChatMetadataContext.Provider>
  );
};

export const useChatMetadata = () => {
  const context = useContext(ChatMetadataContext);
  if (!context) {
    throw new Error('useChatMetadata must be used within ChatMetadataProvider');
  }
  return context;
};
